import React from 'react';
import { TourDetailPage } from '../components/TourDetailPage';
import { indonesiaTours } from '../data/tours';

export const BaliLuxuryPage = () => {
  const tour = indonesiaTours.find(t => t.id === 'bali-luxury-retreat');
  return <TourDetailPage tour={tour} />;
};
